import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import Provisorio from './Provisorio'
import { HelmetProvider } from 'react-helmet-async'
import reportWebVitals from './reportWebVitals'
import 'bootstrap/dist/css/bootstrap.min.css'
import './style.css'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Provisorio />
    </HelmetProvider>
  </React.StrictMode>
)

reportWebVitals()